import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import '@vkontakte/vkui/dist/vkui.css'
import App from './App.jsx'
import { ErrorBoundary } from './components/ErrorBoundary'
import { setupGlobalErrorHandlers } from './utils/errorReporter'
import { initMetrika } from './utils/metrika'

setupGlobalErrorHandlers()
initMetrika()

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
)
